import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';
import {UnitpriceComponent} from './components/unitprice.component'
const routes = [{
            path:'unitprice',
            component:UnitpriceComponent,
            canActivate:[CanActivateViaAuthGuard]
          }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class UnitpriceRoutingModule { }
